import "mse-tools-masthead-and-footer/lib/css/page-base.css";
import "mse-tools-masthead-and-footer/lib/css/stand-alone-page.css";
import "mse-tool-components/global.css";
import "mse-tool-components/all.css";
import "./src/scss/index.scss";

import { mseGTM } from "mse-tools-masthead-and-footer/lib/mse-gtm";

if (typeof window !== "undefined") {
  mseGTM();
}
